module.exports = __webpack_public_path__ + "img/icon-landscape.3fdf4007.svg";